// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DateNavigator_wrapper__3Z22s","navButton":"DateNavigator_navButton__2Qv-5","dateLabel":"DateNavigator_dateLabel__jQ2-W"};